import script from "./VideoStage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoStage.vue?vue&type=script&setup=true&lang=js"

import "./VideoStage.vue?vue&type=style&index=0&id=1684e8d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1684e8d8"]])

export default __exports__